import { useTranslation } from 'react-i18next';
import type { LearningEngagement } from '@/../../shared/people-learning';

/**
 * "¿Realmente está viendo los videos?" (doc 14/09): punto de color con el
 * detalle en el título. Verde = tiempos plausibles; rojo = videos marcados en
 * menos de 45 s desde el paso anterior; gris = sin actividad.
 */
export function EngagementDot({ engagement, withLabel = false }: { engagement: LearningEngagement; withLabel?: boolean }) {
  const { t } = useTranslation();
  const k = 'people_learning.dash.engagement';
  const { level, fastVideos, videosDone } = engagement;
  const color = level === 'ok' ? 'bg-emerald-500' : level === 'suspicious' ? 'bg-red-500' : 'bg-slate-300 dark:bg-slate-600';
  const label =
    level === 'ok'
      ? t(`${k}.ok`, { count: videosDone, defaultValue: 'Actividad verificada · {{count}} videos vistos' })
      : level === 'suspicious'
        ? t(`${k}.suspicious`, { count: fastVideos, defaultValue: '{{count}} videos marcados sin tiempo de visualización' })
        : t(`${k}.none`, 'Sin actividad detectada');
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground" title={label}>
      <span className={`inline-block h-2 w-2 shrink-0 rounded-full ${color}`} />
      {withLabel && <span>{label}</span>}
    </span>
  );
}
